import { Injectable } from '@angular/core';

import { BehaviorSubject, Subject } from 'rxjs';

import { CONSTANTS } from '@pk/powerkioskutils';
import { environment } from 'src/environments/environment';
import { GraphqlService } from '../graphql/graphql.service';
import { HelperService } from '../shared/helper.service';
import { Breadcrumb, User, UserGridConfig } from '../shared/models';

@Injectable({
	providedIn: 'root',
})
export class AppStateService {
	public isMobile: boolean;

	public onAgentUpdated = new Subject<string>(); // agentId
	public onUserUpdated = new Subject<User>();
	public onSetBreadcrumbs = new BehaviorSubject<Breadcrumb[]>(null);
	public onReady = new Subject<{ app: boolean; direct: boolean; billReader: boolean; isPopupWindow: boolean; isEnergyPortal: boolean }>();
	public onSetDefault = new Subject<string>();
	public onOpenContractPageTab = new Subject<number>();
	public onShowFeedback = new Subject<string>();

	constructor(private graphqlService: GraphqlService) {
		this.isMobile = HelperService.isMobile();
	}

	get isImpersonating(): boolean {
		return !!localStorage.getItem('isImpersonating');
	}

	public setBreadcrumbs(breadcrumbs: Breadcrumb[]): void {
		this.onSetBreadcrumbs.next(breadcrumbs);
	}

	public setReady(ready: { app: boolean; direct: boolean; billReader: boolean; isPopupWindow: boolean; isEnergyPortal: boolean }): void {
		this.onReady.next(ready);
	}

	public showFeedback(page: string): void {
		this.onShowFeedback.next(page);
	}

	public sendIframeParentMessage(message: string): void {
		try {
			parent.postMessage(message, '*');
		} catch (e) {
			console.error(e);
		}
	}

	public async savePageState(gridId: string, field: any): Promise<UserGridConfig> {
		// make sure impersonating suppliers don't override their saved states
		if (gridId === CONSTANTS.userGridConfigs.supplierDashboard && this.isImpersonating && environment.name === 'production') {
			return;
		}

		const result = await this.graphqlService.savePageState(gridId, JSON.stringify(field));
		return result.data.savePageState;
	}
}
